<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid>
        <v-row class="pb-10" align="center" justify="center">
          <img src="../../assets/images/ongfacil.png" :style="$vuetify.breakpoint.smAndDown ? 'width: 40vw': 'width: 10vw'"/>
        </v-row>
        <v-row v-if="!resetarSenha" align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-form ref="formLogin" v-model="validLogin" lazy-validation @submit.prevent="Autenticar()">
              <v-card class="elevation-1">
                <v-toolbar color="primary" dark flat>
                  <v-toolbar-title>Controle de Acesso</v-toolbar-title>
                  <v-spacer/>
                  <info/>
                </v-toolbar>
                <v-card-text>                    
                  <v-text-field type="text" label="CPF/CNPJ" prepend-icon="mdi-domain" v-model="acesso.cnpj" :rules="documentoRules" v-mask="cpfCnpjMask" counter="18" maxlength="18" @blur="acesso.cnpj = (acesso.cnpj || '').toLocaleUpperCase()" dense outlined/>
                  <v-text-field type="text" label="Login" prepend-icon="mdi-account" v-model="acesso.login" :rules="fieldRules" counter="10" maxlength="10" dense outlined/>
                  <v-text-field :type="showPassword ? 'text' : 'password'" label="Senha" prepend-icon="mdi-lock" v-model="acesso.senha" :rules="fieldRules" :append-icon="!showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword" dense outlined/>
                </v-card-text>
                <v-card-actions>
                  <a style="text-decoration: underline;" @click="resetarSenha = true">Esqueci minha senha</a>
                  <div class="flex-grow-1"></div>
                  <v-btn type="submit" color="accent" :loading="loading" :disabled="!validLogin">Entrar</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-col>
        </v-row>
        <v-row v-else align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-form ref="formResetarSenha" v-model="validResetarSenha" lazy-validation @submit.prevent="RecuperarSenha()">
              <v-card class="elevation-1">
                <v-toolbar color="primary" dark flat>
                  <v-toolbar-title>Esqueci Minha Senha</v-toolbar-title>
                  <v-spacer/>
                  <info/>
                </v-toolbar>
                <v-card-text>                    
                  <v-text-field label="CPF/CNPJ" prepend-icon="mdi-domain" v-model="acesso.cnpj" :rules="documentoRules" v-mask="cpfCnpjMask" counter="18" maxlength="18" @blur="acesso.cnpj = (acesso.cnpj || '').toLocaleUpperCase()" dense outlined/>
                  <v-text-field label="Login/E-mail" prepend-icon="mdi-account" v-model="acesso.login" :rules="fieldRules" dense outlined/>
                </v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="secondary" :loading="loading" @click="resetarSenha = false">Voltar</v-btn>
                  <v-btn type="submit" color="accent" :loading="loading" :disabled="!validResetarSenha">Enviar</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-row dense class="mt-4">
              <v-col cols="6" class="text-center">
                <a class="mx-6" style="color: gray; text-decoration: underline" href="https://www.bliks.org.br/" target="_blank">Sobre</a>
              </v-col>
              <v-col cols="6" class="text-center">
                <a class="mx-6" style="color: gray; text-decoration: underline" href="https://api.whatsapp.com/send?phone=5521971175743" target="_blank">Suporte</a>                
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>

      <!-- <v-dialog v-model="resetarSenha" width="60vw">
        <v-card v-if="resetarSenha">
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="resetarSenha = false"><v-icon>mdi-close</v-icon></v-btn>
            <v-toolbar-title>Esqueci Minha Senha</v-toolbar-title>
            <v-spacer/>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field type="text" label="CPF/CNPJ" prepend-icon="mdi-domain" v-model="acesso.cnpj" :rules="documentoRules" v-mask="mskCnpjAlfa" counter="18" maxlength="18" @blur="acesso.cnpj = (acesso.cnpj || '').toLocaleUpperCase()"/>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field type="text" label="Login ou e-mail" prepend-icon="mdi-account" v-model="acesso.login"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <span style="color: red">*Se o e-mail demorar a aparecer na caixa de entrada, por favor verifique na caixa de spam.</span>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn type="submit" color="accent" :loading="loading" @click="RecuperarSenha()">Enviar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->

    </v-content>
  </v-app>
</template>

<script>

import AutenticadorService from '../../core/services/geral/AutenticadorService';
import UsuarioService from '../../core/services/geral/UsuarioService';
import { ObterCnpjFormatavel, ObterCpfFormatavel, ObterDocumentoLimpo } from '@/core/domain/shared/Global';
import Swal from 'sweetalert2'

export default {
  data(){
    return {
      acesso: {
        cnpj: '',
        login: '',
        senha: ''
      },
      service: new AutenticadorService(),
      usuarioService: new UsuarioService(),
      lembreMe: false,
      validLogin: true,
      validResetarSenha: true,
      loading: false,
      showPassword: false,
      resetarSenha: false,
      maskCpfCnpj: (process.env.VUE_APP_MSK_CPF_CNPJ || 'XXX.XXX.XXX-XX').replace(/#/g, 'X'),
      mskCnpjAlfa: process.env.VUE_APP_MSK_CNPJ_ALFA || 'XX.XXX.XXX/XXXX-##',
      fieldRules: [
        v => !!v || 'Campo obrigatório'
      ],
      documentoRules: [
        v => !!v || 'Campo obrigatório',
        v => this.DocumentoValido(v) || 'CPF/CNPJ incompleto'
      ],
    }
  },
  computed: {
    cpfCnpjMask: {
      cache: false,
      get(){
        const documento = this.ObterDocumentoLimpo(this.acesso.cnpj || '');
        if (/[A-Z]/.test(documento) || documento.length > 11) {
          return this.mskCnpjAlfa;
        }

        return [this.maskCpfCnpj, this.mskCnpjAlfa];
      }
    }
  },
  methods: {
    ObterDocumentoLimpo(valor){
      return ObterDocumentoLimpo(valor);
    },
    ObterDocumentoFormatavel(valor){
      const documento = this.ObterDocumentoLimpo(valor);
      const usarCnpj = /[A-Z]/.test(documento) || documento.length > 11;

      if (!usarCnpj) {
        return {
          documento: ObterCpfFormatavel(documento),
          usarCnpj
        };
      }

      return {
        documento: ObterCnpjFormatavel(documento),
        usarCnpj
      };
    },
    DocumentoValido(valor){
      const { documento, usarCnpj } = this.ObterDocumentoFormatavel(valor);
      return usarCnpj ? /^[A-Z0-9]{12}[0-9]{2}$/.test(documento) : /^[0-9]{11}$/.test(documento);
    },
    MostrarAlerta(titulo, mensagem){
      const possuiHtml = /<\/?[a-z][\s\S]*>/i.test(mensagem || '');
      const config = {
        title: titulo,
        icon: 'warning',
        type: 'warning'
      };

      if (possuiHtml) {
        config.html = mensagem;
      } else {
        config.text = mensagem;
      }

      Swal.fire(config);
    },
    Autenticar(){
      this.acesso.cnpj = (this.acesso.cnpj || '').toLocaleUpperCase();
      if (!this.$refs.formLogin.validate()) return;

      this.loading = true;
      this.service.AutenticarUsuario(this.acesso).then(
        res => {            
          // this.$swal('Aviso', 'Login efetuado com sucesso!', res.status == 200 ? 'success' : 'warning');
          Swal.fire({
            toast: true,
            // position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            title: 'Login efetuado com sucesso!',
          });
          this.acesso.login = '';
          this.acesso.senha = '';
          localStorage.setItem('sessionApp', JSON.stringify(res.data));
          this.$router.push({ name: 'principal' })
        }, 
        err => {
          localStorage.removeItem('sessionApp');
          this.MostrarAlerta('Aviso', err.response.data);
        }
      ).finally(()=>{
        this.loading = false;
      });
    },
    RecuperarSenha(){
      this.acesso.cnpj = (this.acesso.cnpj || '').toLocaleUpperCase();
      if (!this.$refs.formResetarSenha.validate()) return;

      this.loading = true;
      this.usuarioService.ResetarSenha(this.acesso.cnpj, this.acesso.login).then(
        res =>{
          this.MostrarAlerta('Aviso', res.data);
          this.resetarSenha = false;
          this.acesso = {
            cnpj: '',
            login: '',
            senha: ''
          }
        },
        err => this.MostrarAlerta('Aviso', err.response.data)
      ).finally(() => {
        this.loading = false;
      })
    }
  },
  created(){
    if(this.$route.query.esqueceuSenha){
      this.resetarSenha = true;
    }
  }
}
</script>
